const collator = new Intl.Collator('en-US-x-icu');

export default function sortWithCollation(array, [keyGetter]) {
	return [...array].sort((a,b) => collator.compare(keyGetter(a), keyGetter(b)));
}
